import { connect } from 'react-redux';
import { getCampaign, getCharity } from '../../selectors/apiSelectors';
import { IAppState } from '../../types/state.d';
import CauseCard from '../../components/CauseCard/CauseCard';
import config from '../../config';

type CauseCardContainerOwnProps = {
  className?: string;
};

export const mapStateToProps = (
  state: IAppState,
  ownProps: CauseCardContainerOwnProps,
) => {
  const campaign = getCampaign(state);
  const title = campaign.title;
  const { name, logo } = getCharity(state);

  return {
    name: title || name,
    logo: `${config.imageAPIBaseURL}/${logo}`,
    parentName: title ? name : '',
    className: ownProps.className || '',
  };
};

export default connect(mapStateToProps)(CauseCard);
